import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';

export const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showNotification, setShowNotification] = useState(false);

  // Use useEffect to check sessionStorage on component mount
  useEffect(() => {
    const hasSeenAd = sessionStorage.getItem('motichur-laddu-ad');
    if (!hasSeenAd) {
      setShowNotification(true);
    }
  }, []);

  const handleCloseNotification = useCallback(() => {
    setShowNotification(false);
    sessionStorage.setItem('motichur-laddu-ad', 'true');
  }, []);
  
  const featuredProducts = useMemo(() => ([
    {
      name: 'Gulab Jamun',
      telugu: 'గులాబ్ జామున్',
      image: 'https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1200,h_800/v1754162801/Gulab_lexsqf.png',
      description: 'Soft, spongy milk solid balls soaked in aromatic sugar syrup',
      isNew: true
    },
    {
      name: 'Sakinalu',
      telugu: 'సకినాలు',
      image: 'https://res.cloudinary.com/duhabjmtf/image/upload/v1753897576/sakinalu_xvnccr.jpg',
      description: 'Crispy spiral snacks made with rice flour and sesame seeds'
    },
    {
      name: 'Ariselu',
      telugu: 'అరిసెలు',
      image: 'https://res.cloudinary.com/duhabjmtf/image/upload/v1753898150/ARI_f4okfn.png',
      description: 'Sweet rice flour cakes coated with jaggery syrup'
    },
    {
      name: 'Bondhi Laddu',
      telugu: 'బొంది లడ్డు',
      image: 'https://res.cloudinary.com/duhabjmtf/image/upload/v1753898501/LD_-2_hr07aa.png',
      description: 'Sweet spherical desserts made from gram flour pearls'
    }
  ]), []);

  const scrollingOffers = useMemo(() => ([
    { icon: 'restaurant', text: 'Gulab Jamun starting at just ₹80' },
    { icon: 'currency_rupee', text: 'Affordable Prices' },
    { icon: 'favorite', text: 'Home Made by Mothers with Love' }
  ]), []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredProducts.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [featuredProducts.length]);

  // Font loading
  useEffect(() => {
    const materialIcons = "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
    const josefinSans = "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
    const domine = "https://fonts.googleapis.com/css2?family=Domine:wght@400..700&display=swap";
    const cinzel = "https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap";
    
    [materialIcons, josefinSans, domine, cinzel].forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }, []);

  return (
    <div className="min-h-screen" style={{backgroundColor: '#FFB300'}}>
      
      {/* New Product Launch Overlay */}
      {showNotification && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70 transition-opacity duration-300">
          <div className="relative w-full max-w-4xl mx-auto rounded-3xl overflow-hidden shadow-2xl animate-fade-in-scale" style={{backgroundColor: '#D62828'}}>
            
            {/* Close Button */}
            <button
              onClick={handleCloseNotification}
              className="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:text-white bg-black/20 hover:bg-black/40 transition-colors duration-200"
              aria-label="Close notification"
            >
              <span className="material-symbols-outlined text-xl">close</span>
            </button>
            
            {/* Banner Content - Flex layout for image and text */}
            <div className="flex flex-col md:flex-row items-center justify-center p-6 sm:p-8 md:p-10 text-center md:text-left gap-6 md:gap-10">
              
              {/* Image Container */}
              <div className="flex-shrink-0 w-full md:w-1/2 max-w-sm"> {/* Adjust max-w to control image size further */}
                <img
                  src="https://res.cloudinary.com/duhabjmtf/image/upload/c_pad,b_gen_fill,w_1600,h_1200/v1757523711/moti_fu1ymh.png"
                  alt="Motichur Laddu"
                  className="w-full h-auto object-cover rounded-2xl border-4 border-white/50 shadow-lg"
                />
              </div>

              {/* Text and Buttons Container */}
              <div className="flex-grow flex flex-col items-center md:items-start md:w-1/2">
                <h3 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{fontFamily: 'Yeseva One, serif'}}>
                  New Launch!
                </h3>
                <p className="text-lg sm:text-xl text-white font-medium mb-6 leading-relaxed" style={{fontFamily: 'Domine, serif'}}>
                  The Most Requeseted Item "MOTICHUR LADDU" is  HERE!!!
                </p>
                <Link 
                  to="/products#motichur-laddu" 
                  onClick={handleCloseNotification}
                  className="px-8 sm:px-10 py-3.5 sm:py-4 rounded-full font-bold text-base sm:text-lg transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl"
                  style={{backgroundColor: '#ffb300', color: '#185E20'}}
                >
                  Order Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Scrolling Promotional Banner */}
      <div className="relative overflow-hidden py-3" style={{backgroundColor: '#D62828'}}>
        <div className="animate-scroll-smooth whitespace-nowrap will-change-transform">
          <span className="text-white font-medium text-sm sm:text-base" style={{fontFamily: 'Domine, serif', fontWeight: '500'}}>
            {scrollingOffers.map((offer, index) => (
              <span key={index} className="inline-flex items-center gap-2 px-6 sm:px-12">
                <span className="material-symbols-outlined text-yellow-300" style={{fontSize: '18px', fontWeight: '600'}}>
                  {offer.icon}
                </span>
                <span className="font-semibold tracking-wide cinzel-regular" style={{fontFamily: '"Cinzel", serif', fontWeight: '600'}}>{offer.text}</span>
                <span className="text-yellow-300 mx-2 sm:mx-3 text-lg">•</span>
              </span>
            )).concat(scrollingOffers.map((offer, index) => (
              <span key={`repeat-${index}`} className="inline-flex items-center gap-2 px-6 sm:px-12">
                <span className="material-symbols-outlined text-yellow-300" style={{fontSize: '18px', fontWeight: '600'}}>
                  {offer.icon}
                </span>
                <span className="font-semibold tracking-wide cinzel-regular" style={{fontFamily: '"Cinzel", serif', fontWeight: '600'}}>{offer.text}</span>
                <span className="text-yellow-300 mx-2 sm:mx-3 text-lg">•</span>
              </span>
            )))}
          </span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        {/* Animated Background Pattern */}
        <div className="absolute inset-0 opacity-10 overflow-hidden">
          <div className="absolute top-10 sm:top-20 left-5 sm:left-10 w-16 sm:w-32 h-16 sm:h-32 rounded-full animate-pulse" style={{backgroundColor: '#D62828'}}></div>
          <div className="absolute top-20 sm:top-40 right-10 sm:right-20 w-12 sm:w-24 h-12 sm:h-24 rounded-full animate-bounce" style={{backgroundColor: '#185E20'}}></div>
          <div className="absolute bottom-16 sm:bottom-32 left-1/4 w-10 sm:w-20 h-10 sm:h-20 rounded-full animate-pulse" style={{backgroundColor: '#FFD54F'}}></div>
          <div className="absolute bottom-10 sm:bottom-20 right-1/3 w-14 sm:w-28 h-14 sm:h-28 rounded-full animate-bounce" style={{backgroundColor: '#D62828'}}></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 py-12 sm:py-20">
          {/* Main Hero */}
          <div className="text-center mb-12 sm:mb-20">
            <div className="mb-6 sm:mb-8">
              <h1 className="text-4xl sm:text-6xl md:text-8xl font-bold mb-3 sm:mb-4 animate-fade-in">
                <span style={{color: '#D62828', fontFamily: 'Yeseva One, serif'}} className="ml-2 sm:ml-3">Telugu's</span>
                <span style={{color: '#185E20', fontFamily: 'Yeseva One, serif'}} className="ml-1 sm:ml-2">Kitchen</span>
              </h1>
              <div className="w-20 sm:w-32 h-1 mx-auto mb-4 sm:mb-6 animate-pulse" style={{backgroundColor: '#D62828'}}></div>
              <p className="text-lg sm:text-2xl md:text-3xl font-medium px-4" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
                Traditionally Made - Telangana Foods
              </p>
            </div>
            
            <p className="text-lg sm:text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed mb-8 sm:mb-12 animate-fade-in px-4" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
              Experience the rich heritage of Telangana with our authentic, 
              handcrafted traditional foods made from time-honored family recipes passed down through generations.
            </p>



            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
              <Link to="/products"
                className="group w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg text-white shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 relative overflow-hidden"
                style={{backgroundColor: '#D62828'}}
              >
                <span className="material-symbols-outlined" style={{fontSize: '20px'}}>shopping_bag</span>
                <span>Explore Products</span>
                <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
              <Link to="/about"
                className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg border-2 hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-center flex items-center justify-center gap-2"
                style={{color: '#185E20', borderColor: '#185E20', backgroundColor: 'rgba(255, 255, 255, 0.3)'}}
              >
                <span className="material-symbols-outlined" style={{fontSize: '20px'}}>info</span>
                <span>Our Story</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Carousel */}
      <section className="py-12 sm:py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4" style={{color: '#D62828', fontFamily: 'Yeseva One, serif'}}>
              Featured Delicacies
            </h2>
            <p className="text-lg sm:text-xl px-4" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
              Discover our most loved traditional treats
            </p>
          </div>

          {/* Carousel */}
          <div className="relative max-w-5xl mx-auto">
            <div className="rounded-3xl shadow-2xl overflow-hidden border-4 border-white/20" style={{backgroundColor: '#FFD54F'}}>
              <div className="grid grid-cols-1 md:grid-cols-2 h-[32rem] md:h-96 lg:h-[28rem]">
                {/* Image Side */}
                <div className="relative overflow-hidden h-full">
                  <img
                    src={featuredProducts[currentSlide].image}
                    alt={featuredProducts[currentSlide].name}
                    className="w-full h-full object-cover transition-all duration-700 hover:scale-110"
                    onError={(e) => { 
                      e.target.onerror = null; 
                      e.target.src = "https://placehold.co/600x500/FFD700/000000?text=Traditional+Food"; 
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
                  
                  {/* New Launch Badge for Gulab Jamun */}
                  {featuredProducts[currentSlide].isNew && (
                    <div className="absolute top-4 left-4 bg-gradient-to-r from-green-600 to-green-700 text-white px-3 py-1 rounded-full text-sm font-bold animate-pulse shadow-lg">
                      <span className="material-symbols-outlined text-sm mr-1">new_releases</span>
                      New Launch
                    </div>
                  )}
                </div>

                {/* Content Side */}
                <div className="p-6 sm:p-8 md:p-12 flex flex-col justify-center text-center relative">
                  <div className="mb-6">
                    <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2" style={{color: '#D62828', fontFamily: 'Yeseva One, serif'}}>
                      {featuredProducts[currentSlide].name}
                    </h3>
                    <p className="text-xl sm:text-2xl md:text-3xl mb-4" style={{color: '#185E20', fontFamily: 'NTR, sans-serif'}}>
                      {featuredProducts[currentSlide].telugu}
                    </p>
                    
                    <p className="text-base sm:text-lg leading-relaxed" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
                      {featuredProducts[currentSlide].description}
                    </p>
                  </div>
                  
                  {/* Navigation Dots */}
                  <div className="flex justify-center mb-4">
                    <div className="flex gap-2">
                      {featuredProducts.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentSlide(index)}
                          className={`w-3 h-3 rounded-full transition-all duration-300 ${
                            index === currentSlide ? 'scale-150 shadow-lg' : 'opacity-50 hover:opacity-75'
                          }`}
                          style={{backgroundColor: '#D62828'}}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 sm:py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4" style={{color: '#D62828', fontFamily: 'Yeseva One, serif'}}>
              Why Choose Us?
            </h2>
            <p className="text-lg sm:text-xl max-w-2xl mx-auto px-4" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
              We bring you the authentic taste of Telangana with uncompromised quality
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
            {[
              {
                icon: 'workspace_premium',
                title: 'Premium Quality',
                description: 'We use only the finest ingredients sourced from trusted suppliers to ensure authentic taste and premium quality.'
              },
              {
                icon: 'temple_hindu',
                title: 'Traditional Recipes',
                description: 'Our recipes have been passed down through generations, preserving the authentic flavors of Telangana cuisine.'
              },
              {
                icon: 'schedule',
                title: 'Fresh Daily',
                description: 'All our products are made fresh daily using traditional methods to maintain the original taste and texture.'
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="group p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 text-center border-2 border-white/20"
                style={{backgroundColor: '#FFD54F'}}
              >
                <div className="text-5xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="material-symbols-outlined" style={{fontSize: '48px', color: '#D62828'}}>
                    {feature.icon}
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-4" style={{color: '#D62828', fontFamily: 'Yeseva One, serif'}}>
                  {feature.title}
                </h3>
                <p className="text-base leading-relaxed" style={{color: '#545454', fontFamily: 'Frank Ruhl Libre, serif'}}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        .cinzel-regular {
          font-family: "Cinzel", serif;
          font-optical-sizing: auto;
          font-weight: 600;
          font-style: normal;
        }
        
        .material-symbols-outlined {
          font-family: 'Material Symbols Outlined';
          font-weight: normal;
          font-style: normal;
          font-size: inherit;
          line-height: 1;
          letter-spacing: normal;
          text-transform: none;
          display: inline-block;
          white-space: nowrap;
          direction: ltr;
          -webkit-font-feature-settings: 'liga';
          -webkit-font-smoothing: antialiased;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 48;
        }
        
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        @keyframes fade-in-scale {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in-scale {
          animation: fade-in-scale 0.5s ease-out;
        }

        @keyframes scroll-smooth {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-smooth {
          animation: scroll-smooth 15s linear infinite;
        }
        
        @media (max-width: 640px) {
          .animate-scroll-smooth {
            animation: scroll-smooth 10s linear infinite;
          }
        }
      `}</style>
    </div>
  );
};